import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatGs } from "@/lib/format";
import { Trophy, Target } from "lucide-react";

const medal = (i) => ["text-amber-400", "text-zinc-300", "text-orange-400"][i] || "text-muted-foreground";

const Board = ({ title, icon: Icon, rows, render, tid, empty }) => (
  <div className="card-surface p-5" data-testid={tid}>
    <h3 className="font-head font-bold mb-4 flex items-center gap-2"><Icon className="w-4 h-4 text-primary" /> {title}</h3>
    <div className="space-y-2">
      {rows.length === 0 && <p className="text-sm text-muted-foreground text-center py-6">{empty}</p>}
      {rows.map((r, i) => (
        <div key={r.cashier_id} className={`flex items-center gap-3 p-3 rounded-lg ${i === 0 ? "bg-primary/10 border border-primary/30" : "bg-secondary"}`} data-testid={`${tid}-row-${i}`}>
          <span className={`font-head font-extrabold text-lg w-6 ${medal(i)}`}>{i + 1}</span>
          <span className="flex-1 font-semibold truncate">{r.name}</span>
          {render(r)}
        </div>
      ))}
    </div>
  </div>
);

export const CashierRanking = ({ location, refresh }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/reports/ranking", { params: { days: 7, ...(location ? { location } : {}) } }).then((r) => setData(r.data)).catch(() => {});
  }, [location, refresh]);
  if (!data) return null;
  return (
    <div className="mb-6">
      <p className="text-[10px] font-bold tracking-widest text-muted-foreground mb-2">RANKING DE CAJEROS · ÚLTIMOS 7 DÍAS (desde {data.since.split("-").reverse().join("/")})</p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Board title="Quién vendió más" icon={Trophy} rows={data.sales} tid="ranking-sales" empty="Sin ventas en la semana"
          render={(r) => <div className="text-right"><p className="font-data font-bold text-primary">{formatGs(r.total)}</p><p className="text-[11px] text-muted-foreground">{r.num_sales} ventas</p></div>} />
        <Board title="Menos diferencias de caja" icon={Target} rows={data.accuracy} tid="ranking-accuracy" empty="Sin cierres en la semana"
          render={(r) => <div className="text-right"><p className={`font-data font-bold ${r.abs_diff === 0 ? "text-emerald-500" : "text-amber-500"}`}>{formatGs(Math.round(r.abs_diff / r.closings))} <span className="text-[10px] font-sans text-muted-foreground">prom.</span></p><p className="text-[11px] text-muted-foreground">{r.closings} cierres · neto {formatGs(r.net_diff)}</p></div>} />
      </div>
    </div>
  );
};
